import sensors from "sa-sdk-javascript";
import qs from "qs";
import exposure from "sa-sdk-javascript/dist/web/plugin/exposure/index.es6";

function initSensors(store) {
  let senUrl = process.env.VUE_APP_SENSORS_URL;
  if (
    window.location.hostname.indexOf("51job") > -1 &&
    process.env.NODE_ENV == "production"
  ) {
    senUrl = "https://scdata.51job.com/sa?project=production";
  } else {
    senUrl = process.env.VUE_APP_SENSORS_URL;
  }
  sensors.init({
    // 神策系统配置
    server_url: senUrl, // 数据接收地址
    app_js_bridge: true, //打通app
    is_track_single_page: true, // 单页应用页面浏览事件采集(url改变就触发)
    show_log: process.env.NODE_ENV == "production", // 控制台显示数据开关
    use_client_time: true, //是否使用客户端时间
    send_type: "beacon", //beacon 表示使用 beacon 请求方式发数据
    heatmap: {
      //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
      clickmap: "default",
      //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
      scroll_notice_map: "default",
      collect_tags: {
        div: {
          max_level: 2, // 默认是 1，即只支持叶子 div。可配置范围是 [1, 2, 3],非该范围配置值，会被当作 1 处理。
        },
        img: true,
        p: true,
      },
      custom_property: function (element_target) {
        //点击埋点$element_id
        if (
          element_target.getAttribute("sensor_elementid") != "" &&
          element_target.getAttribute("sensor_elementid") != null
        ) {
          return {
            $element_id: element_target.getAttribute("sensor_elementid"),
          };
        }
      },
    },
  });
  sensors.registerPage({
    //加公共属性
    partner: function () {
      const param = qs.parse(location.search.substring(1));
      if (param.partner) {
        store.commit("setValueLocalStorage", {
          partner: param.partner,
          partnerH5: param.partner,
        });
      } else {
        if (localStorage.getItem("partner")) {
          store.commit("setValueLocalStorage", {
            partner: localStorage.getItem("partner"),
            partnerH5: localStorage.getItem("partner"),
          });
        } else
          store.commit("setValueLocalStorage", { partner: "", partnerH5: "" });
      }
      return store.state.commonStore.partner;
    },
    partnerH5: function () {
      return store.state.commonStore.partnerH5;
    },
    // webId   51为2，应届生为6
    webId: store.getters.webId,
    fromdomain: function () {
      return store.getters.fromdomain;
    },
    frompageUrl: function () {
      return store.state.commonStore.frompageUrl;
    },
    pageUrl: function () {
      return location.href.split("?")[0];
    },
    identityType: function () {
      return store.state.commonStore.identityType;
    },
    userType: function () {
      return store.state.commonStore.userType;
    },
    isLogin: function () {
      return store.state.commonStore.accountId ? "是" : "否";
    },
    accountid: function () {
      return store.state.commonStore.accountId || "";
    },
    uuid: function () {
      return store.state.commonStore.uuid;
    },
    deeplinkid: function () {
      const param = qs.parse(location.search.substring(1));
      if (param.deeplinkid) {
        store.commit("setValueLocalStorage", {
          deeplinkid: param.deeplinkid,
        });
        return param.deeplinkid;
      } else {
        if (localStorage.getItem("deeplinkid")) {
          return localStorage.getItem("deeplinkid");
        } else return "";
      }
    },
    WXShareId: function() {
      const param = qs.parse(location.search.substring(1));
      if (param.userinfo && JSON.parse(param.userinfo).WXShareId) {
        store.commit("setValueLocalStorage", {
          WXShareId: JSON.parse(param.userinfo).WXShareId
        });
      } else {
        if (localStorage.getItem("WXShareId")) {
          store.commit("setValueLocalStorage", {
            WXShareId: localStorage.getItem("WXShareId")
          });
        } else
          store.commit("setValueLocalStorage", { WXShareId: ""});
      }

      return store.state.commonStore.WXShareId;
    },
    groupId: function() {
      return  store.state.commonStore.activityZoneId;
    }
  });
  //曝光埋点
  sensors.use(exposure, {
    area_rate: 0.65,
    stay_duration: 0,
    repeated: false,
  });
}

const sensorsExposure = () => {
  Array.from(document.getElementsByClassName("sensors_exposure")).forEach(
    (item, index) => {
    
      exposure.addExposureView(
        document.getElementsByClassName("sensors_exposure")[index],
        {
          eventName: document
            .getElementsByClassName("sensors_exposure")
            [index].getAttribute("sensorsname"),
          config:
            document
              .getElementsByClassName("sensors_exposure")
              [index].getAttribute("sensorsname") == "JobShortExposure"
              ? { area_rate: 0, stay_duration: 0, repeated: true }
              : { area_rate: 0.65, stay_duration: 0, repeated: false },
          properties: JSON.parse(
            document
              .getElementsByClassName("sensors_exposure")
              [index].getAttribute("sensorsdata")
          ),
          listener:{
            // 已触发曝光回调
            // ele 为当前曝光的元素
            // properties 为曝光元素的元素信息及该元素的曝光自定义属性
            didExpose: function (ele, properties) {
              //缓存曝光过的jobId
              if(ele.getAttribute("sensorsname") == "JobShortExposure" && properties.jobId){
                let exposuredJobIds = [properties.jobId.toString()];
                if(sessionStorage.getItem("exposuredJobIds")){//存有id值，合并重新赋值
                  let newJobIds = exposuredJobIds.concat(JSON.parse(sessionStorage.getItem("exposuredJobIds")));
                  exposuredJobIds = [...new Set(newJobIds)];
                }
                sessionStorage.setItem("exposuredJobIds",JSON.stringify(exposuredJobIds));//存在缓存里
              }
              return true;
            }
          }
        }
      );
    }
  );
};

export default { sensors, sensorsExposure, initSensors };
